import * as React from "react";

import { syncCollaborateThreads } from "../api";
import { useCollaborateStore } from "../store/useCollaborateStore";

export const COLLABORATE_THREAD_POLL_INTERVAL_MS = 10_000;

/** Poll collaborate threads while the pane is active. */
export function useCollaborateThreadPolling(active: boolean, documentId?: string): void {
  const hydrated = useCollaborateStore((s) => s.hydrated);

  React.useEffect(() => {
    if (!active || !hydrated) {
      return undefined;
    }

    const poll = () => {
      void syncCollaborateThreads(documentId);
    };

    poll();
    const intervalId = window.setInterval(poll, COLLABORATE_THREAD_POLL_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, [active, documentId, hydrated]);
}
